var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"division-4"},[_c('div',{staticClass:"text-3 avenirnextltpro-demi-normal-big-stone-19-4px"},[_vm._v("/")])])}]

export { render, staticRenderFns }